import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {OperationStaffItem} from "../types/operation";

const COLLECTION_ID = "operation_staff"
const databases = new Databases(client);

export const operationStaffService = {

  async list(queries: string[] = [], limit: number = 100): Promise<OperationStaffItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as OperationStaffItem);

    } catch (error) {
      throw error;
    }
  },
}